module.exports = require("core-js-pure/stable/instance/for-each");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/for-each.js
// module id = 593
// module chunks = 0